import { render, staticRenderFns } from "./BaseDataTable.vue?vue&type=template&id=5b7a2d3c"
import script from "./BaseDataTable.vue?vue&type=script&lang=ts"
export * from "./BaseDataTable.vue?vue&type=script&lang=ts"
import style0 from "./BaseDataTable.vue?vue&type=style&index=0&id=5b7a2d3c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports